import { useAtom } from "@reatom/npm-react";
import { useMemo } from "react";
import { getAccessRightsMapAtom } from "src/store/fetchers";
import { AccessRightEnum } from "src/types/accessRightsEnum";

export type AccessRightKeys = keyof typeof AccessRightEnum;

export const useCheckRights = (
  requiredRights: AccessRightKeys | AccessRightKeys[],
) => {
  const [userRights] = useAtom(getAccessRightsMapAtom);

  const hasAllRights = useMemo(() => {
    const rightsArray = Array.isArray(requiredRights)
      ? requiredRights
      : [requiredRights];

    return rightsArray.every((right) =>
      checkMissingOrExpiredRights(userRights, right),
    );
  }, [requiredRights, userRights]);

  return hasAllRights;
};

const checkMissingOrExpiredRights = (
  userRights: Map<string, Date>,
  right: AccessRightKeys,
) => {
  const now = Date.now();
  const expiryDate = userRights.get(right)?.getTime();

  return !!expiryDate && expiryDate > now;
};
